import {
  Assignment,
  AssignmentTurnedIn,
  // AssignmentTurnedInIcon,
  BorderColor,
  BorderColorOutlined,
  DnsOutlined,
  EmojiEventsOutlined,
  History,
  HomeOutlined,
  NotificationsActiveOutlined,
  PortraitOutlined,
  SchoolOutlined,
  Settings,
  SupervisorAccountOutlined
} from "@material-ui/icons";
import {
  Logout,
  LogoutOutlined,
  ManageAccountsOutlined,
  QuizOutlined,
} from "@mui/icons-material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import LogoutIcon from "@mui/icons-material/Logout";
import MenuIcon from "@mui/icons-material/Menu";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { Avatar, ListItemButton, Menu, MenuItem, ThemeProvider, Tooltip, useMediaQuery, useTheme } from "@mui/material";
import MuiAppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import MuiDrawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItemIcon from "@mui/material/ListItemIcon";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { createTheme, styled } from "@mui/material/styles";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { LoginContext } from "../contexts/LoginContext";
import ChangePassword from "./ChangePassword";
import ExpiryChip from "./ExpiryChip";
import ParentDetails from "./ParentDetails";
import PersonalDetails from "./PersonalDetails";
import TestViewer from "./TestViewer";
// import Chart from './Chart';
import { makeStyles } from "@material-ui/core";
import { isAfter } from 'date-fns';
import StudentDashboard from "../Dashboard/StudentDashboard";
import { configUrl } from "../config";
import { PackageType } from "../enums/packageTypes";
import getUserTopicsForTestsService from "../services/OwnTestCreationServices/getUserTopicsForTestsService";
import styles from "../styles/HomeScreen.module.css";
import { createAppTheme } from "../theme";
import CollegePredictorDashboard from "./CollegePredictor/CollegePredictorDashboard";
import CustomModal from "./CustomModal/CustomModal";
import Notification from "./HomeMenuComponents/Notification";
import OwnTestCreation from "./OwnTestCreation";
import SwitchProvider from "./SwitchProvider";
import TestSeries from "./TestSeries";
import TransactionPage from "./TransactionPage";

function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      fontFamily={'Poppins'}
      align="center"
      {...props}
      style={{ fontSize: '1.5vh' }}
    >
      <p>&copy; 2026 Splayndid Solutions Private Limited. All rights reserved.</p>
      {/* <p>© 2025 Medineer. All rights reserved. Powered by learningFitbit.</p> */}
    </Typography >
  );
}

const drawerWidth = 280;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: 900,  //theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  "& .MuiDrawer-paper": {
    backgroundColor: theme.palette.drawerBackground.main,    // "#5F5C57",
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    ...(open && {
      ...openedMixin(theme),
      "& .MuiDrawer-paper": openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      "& .MuiDrawer-paper": closedMixin(theme),
    }),
  },
}));

const mdTheme = createTheme();

const useStyles = makeStyles({
  tooltip: {
    fontSize: "1.5em",
    fontFamily: 'Poppins'
  },
});
function DashboardContent() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { t } = useTranslation();
  const classes = useStyles();
  const {
    setUserName,
    userDetail,
    UserName,
    emailC,
    UserId,
    setProviderId,
    providerId,
    setUserId,
    providerName,
    providerKey,
    setUserType,
    pageKey,
    setPageKey,
    setStatus,
    setAssessmet,
    setIsDrawerNavigation,
    status,
    providerList,
    setActiveUserSubscriptionId,
    showSubscriptionData,
    setTrailCourseData,
    setShowSubscriptionData,
    userPrivileges, themeColor, isDefaultSplash,
    packageId, providerDetails
  } = React.useContext(LoginContext);
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const [openlist, setOpenList] = React.useState(false);
  const [openAssessment, setOpenAssessment] = React.useState(false);
  const [expanded, setExpanded] = React.useState(false);
  const [showModel, setShowModel] = React.useState(null);
  // const result = GetProvider();
  // console.log("BalajiSSS", result?.data);  
  console.log("prkey", providerKey);
  let userPrivilege = userPrivileges?.licenseObject ? JSON.parse(userPrivileges?.licenseObject) : "";
  let isCollegePredictorSubscribe = userPrivileges?.isCollegePredictorSubscribed;
  console.log("userPrivilege111", userPrivilege);
  React.useEffect(() => {
    async function fetchData() {
      const resp = await getUserTopicsForTestsService.getTestSubscriptionDetails(UserId);
      console.log("susbcition data is ", resp);
      const date = new Date(resp?.endDate);
      const localDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60 * 1000));
      const now = new Date();
      const isActive = isAfter(localDate, now);
      if (resp) {
        if (resp?.endDate === null && (resp?.subscriptionTypeId === 1 || resp?.subscriptionTypeId === 3)) {
          setActiveUserSubscriptionId(resp?.userSubscriptionId);
        } else {
          if (isActive && (resp?.subscriptionTypeId === 1 || resp?.subscriptionTypeId === 3)) {
            setActiveUserSubscriptionId(resp?.userSubscriptionId); // monthly tests feature subscriptionid is 1
          } else {
            setActiveUserSubscriptionId(0);
          }
        }
        setShowSubscriptionData(resp);
      }
    }
    async function fetchCourseSubscription() {
      const resp = await getUserTopicsForTestsService.getCourseSubscriptionDetails(UserId);
      console.log("course subscription data is ", resp);
      const date = new Date(resp?.endDate);
      const localDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60 * 1000));
      const now = new Date();
      const isActive = isAfter(localDate, now);
      if (resp) {
        if (resp?.subscriptionTypeId === 4) {
          setTrailCourseData(resp); // trail course feature subscriptionid is 4
        }
      }
    }
    if (UserId) {
      fetchData();
      fetchCourseSubscription();
    }

    function handleResize() {
      if (window.innerWidth > 768) {
        setExpanded(true);
      } else {
        setExpanded(false);
      }
    }

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [UserId]);


  const isPrivilege = (x) => {
    const learnerSitePrivileges = userPrivileges?.privileges?.learnerSite['$values'] || [];

    if (learnerSitePrivileges.includes(x)) {
      return true;
    }
    else {
      return false;
    }
  };
  const toggleDrawer = () => {
    setOpen(!open);
    if (window.innerWidth < 768) {
      setExpanded(!expanded);
    }
  };
  const handleClick = () => {
    setOpenList(!openlist);
  };
  const handleAssessmentClick = () => {
    setOpenAssessment(!openAssessment);
  };
  const handleContaint = (value) => {
    console.log(providerKey, "providerkey from screen at logout");
    setStatus("PENDING");
    setIsDrawerNavigation(true);
    setAssessmet(true);
    setPageKey(value);

    console.log("initialNavigate", pageKey, status);
    if (value === 0) {
      sessionStorage.clear();
      sessionStorage.setItem("login", false);
      setActiveUserSubscriptionId(0);                       // resetting active subscription id when logout

      let pylod = userDetail;
      pylod.lastLogInDate = new Date();
      // const savePersonal = onParentInfo(pylod);
      console.log(providerDetails, 'homescrn')
      if (providerDetails?.logoutUrl) {
        navigate(`/signin/${providerDetails?.providerKey}`);
        window.location.href = providerDetails?.logoutUrl
      } else if (isDefaultSplash === false) {
        console.log('redirect to medineer', isDefaultSplash)
        navigate(`/medineer`);  //(/medineer)
      } else {
        // navigate(`/${providerKey}`);
        navigate(`/letStart`);

      }
    }
    toggleDrawer();
  };
  const [anchorEl, setAnchorEl] = React.useState(null);

  const openProfile = Boolean(anchorEl);
  const handleClickProfile = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const onOpenMobileNav = () => {
    setOpen(!open);
    setExpanded(!expanded);
    // toggleDrawer()
  };
  console.log(open, "openval");
  console.log(expanded, "expandedval");
  const showProviderList = async (providerlist) => {
    console.log(providerlist, "providerlists");
    setShowModel(
      <CustomModal
        modal={true}
        setModal={hideEvaluationModel}
        content={<SwitchProvider providerlist={providerlist} />}
        showOk={false}
        showCancel={false}
        onCancelClick={hideEvaluationModel}
        title={t("selectProvider")}
        // maxWidth="lg"
        hideTitle={true}
      // fullWidth={false}
      />
    );
  };
  const hideEvaluationModel = (event, reason) => {
    console.log("reason", reason);
    if (reason === "backdropClick") {
      return;
    }
    setShowModel(null);
  };
  const gradientBackgrounds = {
    // will add it later if req.
    // purple: 'linear-gradient(135deg, #5C4892, #DD2466)',  // Purple gradient
    // green: 'linear-gradient(135deg, #4CAF50, #FF9800)',   // Green gradient
    // blue: 'linear-gradient(135deg, #2196F3, #FFC107)',    // Blue gradient
    // teal: 'linear-gradient(135deg, #029c91, #272740)',    // Teal gradient
    // deamblue: 'linear-gradient(176deg, rgb(18, 47, 117) 20%, rgb(41, 39, 147) 40%,rgb(18, 47, 117))',   //'linear-gradient(170deg, rgb(41, 39, 147) 60%, rgb(18, 53, 151) 90%)' // 'linear-gradient(50deg,rgb(18, 53, 151) 0%,rgb(151, 171, 255)  90%)'  //'linear-gradient(135deg, #97ABFF 10%, #123597 100%)',   //#2196F3, #FFC107)', // Dreamblue gradient
    // vividorange: 'radial-gradient(circle, #DEC08E, #EDEBE8, #E8D7BB )',
    vividgreen: 'linear-gradient(to bottom, #b8dcee, #e9fde0)',
  };

  return (
    <ThemeProvider theme={createAppTheme(themeColor)}>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppBar
          position="absolute"
          open={open}
          sx={{ background: gradientBackgrounds[themeColor], height: '70px' }}     //`${theme.palette.navBackground.main} !important` }}
        >
          {/* new Custom modal when tests are not available */}

          {/* <NewCustomModal/>  */}
          <Toolbar
          // sx={{
          //   pr: "24px", // keep right padding when drawer closed
          // }}
          >
            <IconButton
              edge="start"
              color="white"
              aria-label="open drawer"
              className={styles.webButton}
              onClick={() => onOpenMobileNav()}
              sx={{
                marginRight: "0px",
                ...(open && { display: "none" }),
              }}
            >
              <Tooltip
                classes={{ tooltip: classes.tooltip }}
                title={"Menu"}
                placement="right"
              >
                <MenuIcon style={{ fontSize: 'x-large' }} />
              </Tooltip>
            </IconButton>
            <IconButton
              edge="start"
              color="Black"
              aria-label="open drawer"
              className={styles.mobileButton}
              onClick={toggleDrawer}
              sx={{
                marginRight: "11px",
                ...(open && { display: "none" }),
                background: '#fff',
                borderRadius: 0,
              }}
            >
              <Tooltip
                classes={{ tooltip: classes.tooltip }}
                title={"Menu"}
                placement="right"
              >
                <MenuIcon style={{ fontSize: 'xx-large' }} />
              </Tooltip>
            </IconButton>
            {/* provider name */}
            <Avatar
              alt="Logo"
              src={providerDetails?.logo}
              // className={styles.providerName}
              sx={{ width: 45, height: 45, marginRight: 1, display: providerDetails ? 'block' : 'none' }}
            />
            <Typography
              className={styles.providerName}
              // component="h1"
              // variant="h5"
              // color={theme.palette.navLinks.main}
              // noWrap
              sx={{ flexGrow: 1, textAlign: "start" }}
            >
              {providerName ?? ""}
            </Typography>
            {
              (showSubscriptionData != null && (showSubscriptionData?.subscriptionTypeId === 1 || showSubscriptionData?.subscriptionTypeId === 3)) &&
              (<ExpiryChip expireDate={showSubscriptionData?.endDate} testLeft={showSubscriptionData?.remainingTests ?? 0} />
              )}
            {/* SearchBar */}

            {/* <Paper
                  className={styles.searchBar}
                  component="form"
                  sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 416 }}
                >
                
                  <InputBase
                    sx={{ ml: 1, flex: 1,fontSize:'initial' }}
                    placeholder="Search"
                    
                  />
                  <IconButton type="button" aria-label="search">
                    <SearchIcon className={styles.searchIcon} />
                  </IconButton>
                </Paper> */}

            {/* <IconButton color="Black" onClick={handleClickProfile} aria-controls={openProfile ? 'account-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={openProfile ? 'true' : undefined} >
              <img className={styles.profile} src="Profile.jpg" alt="profileimg" /><br />
              {UserName}
            </IconButton> */}

            {/* Notification */}
            {isPrivilege("Notification") === true ?
              <IconButton onClick={() => handleContaint(2)}>
                <button className={styles.logoutBtn}
                  style={{
                    // backgroundColor: theme.palette.secondaryButtonBackground.main,
                    color: theme.palette.navLinks.main
                  }}
                >
                  <NotificationsIcon style={{ fontSize: "x-large" }} />
                </button>
                <br />
                {/* 
              {t("notification")} */}
              </IconButton>
              : ""
            }

            <IconButton
              onClick={() => {
                handleContaint(0);
              }}
            >
              {/* <Badge badgeContent={4} color="secondary"> */}

              {/* <NotificationsIcon /> */}
              <button className={styles.logoutBtn}
                style={{
                  // backgroundColor: 'transperant !important',
                  color: theme.palette.navLinks.main
                }}
              >
                <LogoutIcon style={{ fontSize: "x-large" }} />
              </button>
              <br />
              {/* 
              {t("logOut")} */}
            </IconButton>
          </Toolbar>
        </AppBar>

        {/*onClick Profile menu  */}
        <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={openProfile}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&:before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: theme.palette.navBackground.main,  // "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          <MenuItem onClick={handleClose}>
            <Avatar /> {t("profile")}
          </MenuItem>
          <Divider />
          <MenuItem onClick={handleClose}>
            <ListItemIcon>
              <BorderColor fontSize="small" />
            </ListItemIcon>
            {t("changePass")}
          </MenuItem>
          <MenuItem onClick={handleClose}>
            <ListItemIcon>
              <Settings fontSize="small" />
            </ListItemIcon>
            {t("settings")}
          </MenuItem>
          <MenuItem onClick={() => handleContaint(0)}>
            <ListItemIcon>
              <Logout style={{ color: "red" }} fontSize="small" />
            </ListItemIcon>
            {t("logOut")}
          </MenuItem>
        </Menu>

        {/* drawer */}
        <Drawer
          variant="permanent"
          style={expanded === false ? { display: "none", zIndex: 800 } : { zIndex: 800 }}
          open={open}
          className={styles.sidebarDashboard}
        >
          <Toolbar className={styles.profileToolbar}>
            <img src="Profile.jpg" alt="profileimg" /> {userDetail?.fullName}{" "}
            <br />
            {/* {emailC} */}
            <IconButton className={styles.iconButton} onClick={toggleDrawer}>
              <MenuIcon style={{ fontSize: 'xx-large', color: '#fff' }} />
            </IconButton>
          </Toolbar>
          <Divider sx={{ border: '1px solid #ffffff' }} />
          {/* dashboard list */}
          <List className={styles.drawerList}>
            {
              userPrivilege?.LearnerHomePage === true ?
                <Tooltip
                  classes={{ tooltip: classes.tooltip }}
                  title={t("home")}
                  placement="right"
                >
                  <ListItemButton
                    className={styles.listItemButton}
                    sx={pageKey === 1 ? { borderRight: '5px solid' } : {}}
                    onClick={() => handleContaint(1)}
                  >
                    <HomeOutlined className={styles.drawerListIcon} /> {t("home")}
                  </ListItemButton>
                </Tooltip> : null
            }
            {
              userPrivilege?.LearnerTestSeriesPage === true ?
                <Tooltip
                  classes={{ tooltip: classes.tooltip }}
                  title={t("assignedTestSeries")}
                  placement="right"
                >
                  <ListItemButton
                    className={styles.listItemButton}
                    sx={pageKey === 6 ? { borderRight: '5px solid' } : {}}
                    onClick={() => handleContaint(6)}>
                    <DnsOutlined className={styles.drawerListIcon} />
                    {t("assignedTestSeries")}
                  </ListItemButton>
                </Tooltip>
                : null
            }
            {
              userPrivilege?.LearnerAssessmentsPage === true ?
                <Tooltip
                  classes={{ tooltip: classes.tooltip }}
                  title={t("assignedTests")}
                  placement="right"
                >
                  <ListItemButton
                    className={styles.listItemButton}
                    sx={pageKey === 5 ? { borderRight: '5px solid' } : {}}
                    onClick={() => handleContaint(5)}>
                    <Assignment className={styles.drawerListIcon} />
                    {t("assignedTests")}
                  </ListItemButton>
                </Tooltip> : null
            }

            <Tooltip
              classes={{ tooltip: classes.tooltip }}
              title={t("quiz")}
              placement="right"
            >
              <ListItemButton className={styles.listItemButton} disabled>
                <QuizOutlined className={styles.drawerListIcon} /> {t("quiz")}
              </ListItemButton>
            </Tooltip>
            <Tooltip
              classes={{ tooltip: classes.tooltip }}
              title={t("myRewards")}
              placement="right"
            >
              <ListItemButton className={styles.listItemButton} disabled>
                <EmojiEventsOutlined className={styles.drawerListIcon} />{" "}
                {t("myRewards")}
              </ListItemButton>
            </Tooltip>
            {
              userPrivilege?.LearnerNotificationPage === true ?
                <Tooltip
                  classes={{ tooltip: classes.tooltip }}
                  title={t("notification")}
                  placement="right"
                >
                  <ListItemButton
                    className={styles.listItemButton}
                    sx={pageKey === 2 ? { borderRight: '5px solid' } : {}}
                    onClick={() => handleContaint(2)}
                    disabled={isPrivilege("Notification") === true ? false : true}
                  >
                    <NotificationsActiveOutlined
                      className={styles.drawerListIcon}
                    />{" "}
                    {t("notification")}
                  </ListItemButton>
                </Tooltip> : null
            }

            {
              userPrivilege?.LearnerProfileUpdatePage === true ?
                <>
                  <Tooltip
                    classes={{ tooltip: classes.tooltip }}
                    title={t("profileUpdate")}
                    placement="right"
                  >
                    <ListItemButton
                      className={styles.listItemButton}
                      onClick={handleClick}
                      disabled={isPrivilege("Profile") === true ? false : true}
                    >
                      <PortraitOutlined className={styles.drawerListIcon} />{" "}
                      {t("profileUpdate")}
                      {openlist ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                  </Tooltip>
                  <Collapse in={openlist} timeout="auto" unmountOnExit>
                    <List
                      component="div"
                      style={{ marginLeft: "10px" }}
                      disablePadding
                    >
                      <Tooltip
                        classes={{ tooltip: classes.tooltip }}
                        title={t("personal/academic")}
                        placement="right"
                      >
                        <ListItemButton
                          sx={pageKey === 3 ? { borderRight: '5px solid' } : {}}
                          onClick={() => handleContaint(3)}
                        >
                          <ManageAccountsOutlined className={styles.drawerListIcon} />
                          {t("personal/academic")}
                        </ListItemButton>
                      </Tooltip>
                      <Tooltip
                        classes={{ tooltip: classes.tooltip }}
                        title={t("parent/sibling")}
                        placement="right"
                      >
                        <ListItemButton
                          sx={pageKey === 4 ? { borderRight: '5px solid' } : {}}
                          onClick={() => handleContaint(4)}
                        >
                          <SupervisorAccountOutlined
                            className={styles.drawerListIcon}
                          />
                          {t("parent/sibling")}
                        </ListItemButton>
                      </Tooltip>
                    </List>
                  </Collapse>
                </> : null

            }
            {
              userPrivilege?.LearnerChangePasswordPage === true ?
                <Tooltip
                  classes={{ tooltip: classes.tooltip }}
                  title={t("changePass")}
                  placement="right"
                >
                  <ListItemButton
                    sx={pageKey === 7 ? { borderRight: '5px solid' } : {}}
                    onClick={() => handleContaint(7)}
                    className={styles.listItemButton}
                    disabled={isPrivilege("ChangePassword") === true ? false : true}
                  >
                    <BorderColorOutlined className={styles.drawerListIcon} />{" "}
                    {t("changePass")}
                  </ListItemButton>
                </Tooltip> : null
            }

            {
              (isPrivilege("CollegePredictor") === true && userPrivilege?.LearnerCollegePredictorPage === true && (providerId === configUrl.MediNeerProviderId ? isCollegePredictorSubscribe === true : true)) ?
                <Tooltip
                  classes={{ tooltip: classes.tooltip }}
                  title={t("collegePredictor")}
                  placement="right"
                >
                  <ListItemButton
                    sx={pageKey === 8 ? { borderRight: '5px solid' } : {}}
                    onClick={() => handleContaint(8)}
                    className={styles.listItemButton}
                  // disabled={packageId === PackageType.TRIAL}
                  >
                    <SchoolOutlined className={styles.drawerListIcon} />{" "}
                    {t("collegePredictor")}
                  </ListItemButton>
                </Tooltip>
                : null
            }

            {/* // Temporarily Hidden */}
            {providerId === configUrl.MediNeerProviderId ?
              <Tooltip
                classes={{ tooltip: classes.tooltip }}
                title={t("pickYourTest")}
                placement="right"
              >
                <ListItemButton
                  sx={pageKey === 9 ? { borderRight: '5px solid' } : {}}
                  onClick={() => handleContaint(9)}
                  className={styles.listItemButton}
                  disabled={packageId === PackageType.TRIAL}
                >
                  <AssignmentTurnedIn className={styles.drawerListIcon} />{" "}
                  {t("pickYourTest")}
                </ListItemButton>
              </Tooltip> : null}
            {
              providerId === configUrl.MediNeerProviderId ?
                <Tooltip
                  classes={{ tooltip: classes.tooltip }}
                  title={t("transactionHistry")}
                  placement="right"
                >
                  <ListItemButton
                    sx={pageKey === 10 ? { borderRight: '5px solid' } : {}}
                    onClick={() => handleContaint(10)}
                    className={styles.listItemButton}
                    disabled={packageId === PackageType.TRIAL}

                  >
                    <History className={styles.drawerListIcon} />{" "}
                    {t("transactionHistry")}
                  </ListItemButton>
                </Tooltip> : null
            }



            {/* Switch Provider BSS121 */}
            {/* <Tooltip
              classes={{ tooltip: classes.tooltip }}
              title={t("selectProvider")}
              placement="right"
            >
              <ListItemButton onClick={() => showProviderList(providerList)} className={styles.listItemButton}>
                <SwitchAccountIcon className={styles.drawerListIcon} />{" "}
                {t("selectProvider")}
              </ListItemButton>
            </Tooltip> */}

            <Tooltip
              classes={{ tooltip: classes.tooltip }}
              title={t("logOut")}
              placement="right"
            >
              <ListItemButton
                className={styles.listItemButton}
                // style={{ color: "red" }}
                onClick={() => handleContaint(0)}
              >
                <LogoutOutlined className={styles.drawerListIcon} />{" "}
                {t("logOut")}
              </ListItemButton>
            </Tooltip>
          </List>
        </Drawer>
        {/* dashboard screens pages */}
        <Box
          component="main"
          sx={{
            // backgroundColor: (theme) =>
            //   theme.palette.mode === "light"
            //     ? theme.palette.grey[100]
            //     : theme.palette.grey[900],
            background: theme.palette.background.main,  //"#EFD7AF80",
            flexGrow: 1,
            height: "100vh",
            overflow: "auto",
          }}
        >
          <Toolbar />
          <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            {pageKey === 1 ? <StudentDashboard /> : ""}
            {pageKey === 2 ? <Notification /> : ""}
            {pageKey === 3 ? <PersonalDetails /> : ""}
            {pageKey === 4 ? <ParentDetails /> : ""}
            {pageKey === 5 ? <TestViewer /> : ""}
            {pageKey === 6 ? <TestSeries /> : ""}
            {pageKey === 7 ? <ChangePassword /> : ""}
            {pageKey === 8 ? <CollegePredictorDashboard /> : ""}
            {/* {pageKey === 8 ? <CollegePredictors /> : ""} */}
            {pageKey === 9 ? <OwnTestCreation /> : ""}
            {pageKey === 10 ? <TransactionPage /> : ""}
            <Copyright sx={{ pt: 4 }} />
          </Container>
        </Box>
        {showModel}
      </Box>
    </ThemeProvider>
  );
}

export default function Dashboard() {
  return <DashboardContent />;
}
